//import "./safetyforms.css";
import { useEffect, useState } from "react";
import "react-dropdown/style.css";
import { FaBuilding, FaCalendar, FaFilter, FaMapMarkerAlt, FaSearch, FaUser } from "react-icons/fa";
import { BlackButton, LightButton } from "./Buttons";
import { DropdownContainer, DropdownContent } from "./Dropdown";
import FormDatePicker from "./FormDatePicker";
import FormSelectCrewMember from "./FormSelectCrewMember";
import FormSelectCustomer from "./FormSelectCustomer";
import FormSelectSafetyFormFilter from "./FormSelectSafetyFormFilter";
import Row from "./Row";

const FormFilterDropDown = ({ form, locationId, onFilter, showDraftButton }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const hideDropDown = () => setVisible(false);
        window.addEventListener('click', hideDropDown);
        return () => window.removeEventListener('click', hideDropDown);
    }, [])

    const filterBy = form.watch("filterBy");
    const startDate = form.watch("startDate");
    const endDate = form.watch("endDate");

    const onSubmit = (filterValues) => {
        setVisible(false);
        onFilter(filterValues);
    }

    const disableDateInput = filterBy.value === 'byLocation' || filterBy.value === 'bySearch'

    const filterIcon = {
        byCustomer: <FaBuilding />,
        byLocation: <FaMapMarkerAlt />,
        byDate: <FaCalendar />,
        byAuthor: <FaUser />,
        byForeman: <FaUser />,
        bySearch: <FaSearch />,
    }

    return (
        <DropdownContainer onClick={(e) => e.stopPropagation()}>
            <LightButton onClick={(e) => { e.stopPropagation(); setVisible(!visible); }}>
                Filter By
                <FaFilter /> : {filterIcon[filterBy.value]}
            </LightButton>
            <DropdownContent style={{ display: visible ? 'flex' : 'none', flexDirection: 'column', padding: '1rem', minWidth: '600px', gap: '1rem' }}>
                <Row>
                    <FormSelectSafetyFormFilter {...form} name="filterBy" label="Filter By" rules={{ required: true }} />
                    {filterBy?.value === "byCustomer" && <FormSelectCustomer name="customerId" {...form} locationId={locationId} label="Customer" rules={{ required: true }} />}
                    {["byForeman", "byAuthor"].includes(filterBy?.value) && <FormSelectCrewMember showAll name="crewMemberId" {...form} locationId={locationId} label="Crew Member" rules={{ required: true }} />}
                </Row>
                <Row>
                    <FormDatePicker {...form} disabled={disableDateInput} name="startDate" label="Start Date" placeholder="Select start date" maxDate={endDate} startDate={startDate} endDate={endDate} rules={{ required: true }} />
                    <FormDatePicker {...form} disabled={disableDateInput} name="endDate" label="End Date" placeholder="Select end date" minDate={startDate} startDate={startDate} endDate={endDate} rules={{ required: true }} />
                </Row>
                <BlackButton onClick={form.handleSubmit(onSubmit)} disabled={form.formState?.isSubmitting || !form.formState?.isValid} style={{ alignSelf: 'flex-start' }}>Filter</BlackButton>
            </DropdownContent>
        </DropdownContainer>
    )
}

export default FormFilterDropDown;